/**
 * Safely renders an HTML template string with dynamic attributes.
 *
 * This function takes an HTML-like template string (containing placeholders in `{key}` format)
 * and an attributes object, then replaces each placeholder with the corresponding escaped value.
 * After substitution, the resulting HTML is sanitized using DOMPurify.
 */

import DOMPurify from "dompurify";

export function renderSafeHtml(tpl: string, attrs: Record<string, any>) {
    const html = tpl.replace(/\{([^}]+)\}/g, (_, key) => {
        const v = attrs?.[key] ?? "";
        const div = document.createElement("div");
        div.textContent = String(v);
        return div.innerHTML;
    });
    return DOMPurify.sanitize(html, { 
        USE_PROFILES: { html: true },
        ADD_ATTR: ['target']
    });
}
